<!--
 * @FileDescription: 退款审批对话框
 * @Author: 陈文景
 * @Date: 2022-11-10 11:41:56
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div>
    <el-dialog title="退款审批" :visible.sync="visible" width="780px" :before-close="close">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="审核状态" prop="status">
          <el-radio-group v-model="form.status" @input="inputRadioGroup">
            <el-radio :label="1">同意</el-radio>
            <el-radio :label="0">不同意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片上传">
          <div class="imageListBox f fw-w">
            <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :multiple="true"
                :before-upload="file => imgUploadBefore(form.imageList, file, form)"
                v-if="mode !== 'read'">
                <i class="el-icon-plus"></i>
            </el-upload>
            <template v-if="imageLoading">
                <div style="width:90px;height:90px" v-loading="true" v-for="(file, index) in uploadImageList" :key="index"></div>
            </template>
            <template v-else>
              <div class="pictureCard" v-for="(imgUrl, index) in form.imageList" :key="imgUrl">
                  <img :src="imgUrl" @click="imgVisit(imgUrl)">
                  <i class="el-icon-close" @click="imgUrlDelete(form.imageList, index)" v-if="mode !== 'read'"></i>
                  <div class="deleteIcon" @click="imgUrlDelete(form.imageList, index)" v-if="mode !== 'read'"></div>
              </div>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="原因" prop="reason" style="margin-top:20px;">
          <el-input v-model="form.reason" type="textarea" maxlength="500" show-word-limit :rows="6" resize="none" placeholder="请输入英文" />
        </el-form-item>
      </el-form>

      <span class="tips">注: 审核前需确认申请的SKU在kaka ERP已经撤单, 审核成功后会进行强制退款(原路返回)</span>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">取 消</el-button>
        <el-button size="medium" type="primary" @click="save">确 认</el-button>
      </span>
    </el-dialog>
  
    <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl">
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import ImageCompressor from 'js-image-compressor'

/**
 * 校验字符串是否包含中文
 */
let isChinese = (rule, value, callback) => {
  let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
  if (reg.test(value)) {
    callback(new Error('退款原因不能包含中文字符！'))
  } else {
    callback()
  }
}

/**
 * 校验字符串是否包含中文
 */
let isRefuseChinese = (rule, value, callback) => {
  let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
  if (!value) {
    callback(new Error('请输入退款原因！'))
  } else if (reg.test(value)) {
    callback(new Error('退款原因不能包含中文字符！'))
  } else {
    callback()
  }
}

let form = {
  status: undefined, // 0.拒绝 1.同意
  reason: undefined, // 退款原因
  imageList: []
}

export default {
  data() {
    return {
      visible: false,
      returnsId: undefined,
      mode: 'add',
      imageLoading: false,
      dialogImageUrl: '',
      dialogVisible: false,
      uploadImageTimer: null,
      uploadImageList: [],
      imageSignValue: '', // 图片上传唯一凭证
      
      form: { ...form },

      rules: {
        status: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        reason: [{ required: false, validator: isChinese, trigger: 'change' }]
      }
    }
  },
  async mounted() {
    let imageSignValue = await API.customProductGetSignValue({ directory: 'common/images/' })
    this.imageSignValue = imageSignValue.data
  },
  methods: {
    inputRadioGroup(value) {
      if (value === 0) {
        this.rules.reason = [{ required: true, validator: isRefuseChinese, trigger: 'change' }]
      }
      if (value === 1) {
        this.$refs.form.clearValidate('reason')
        this.rules.reason = [{ required: false, validator: isChinese, trigger: 'change' }]
      }
    },

    show(id) {
      this.visible = true
      this.returnsId = id
    },

    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let { code, message } = await API.initiateProcessRefund(this.returnsId, { ...this.form })
          if (code === 10000) {
            this.close()
            this.$emit('update')
            this.$message.success(message)
          } else {
            this.$message.error(message)
          }
        } else {
          return false
        }
      })
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {
      this.form = { ...form }
      this.returnsId = undefined
      this.$refs.form.resetFields()
    },
    imgUploadBefore(arr, file, form) {
      if ((file.size / 1024 / 1024) > 5){
        this.$message.error('最大图像支持为5M，格式支持：jpg、png、gif')
        return false
      }
      if (['image/png', 'image/jpeg', 'image/webp'].includes(file.type)){
        if ((arr.length + this.uploadImageList.length) < 5) {
          this.uploadImageList.push(file)
          if (this.uploadImageTimer) {
            clearTimeout(this.uploadImageTimer)
          }
          this.uploadImageTimer = setTimeout(() => {
            this.imgUploadHandle(arr, form)
          }, 100)
        }else{
          this.$message.error('最多只能上传5张图片')
          this.uploadImageList = []
        }
      }else{
        this.$message.error('只能上传图片')
        this.uploadImageList = []
      }
      return false
    },
    imgUploadHandle(arr, form) {
      const that = this
      const imgFormData = new FormData()
      imgFormData.append('directory', 'common/images/')
      imgFormData.append('signValue', that.imageSignValue)
      let alReadyCompressList = []
      this.imageLoading = true
      that.uploadImageList.map(e => alReadyCompressList.push(this.imageCompressorHandle(e)))
      Promise.all(alReadyCompressList).then(() => {
        alReadyCompressList.forEach(e => e.then(res => imgFormData.append('fileList', res)))
        API.orderUploadFile(imgFormData).then(res => {
        // styleFormObj存放的key
          if (form.imageList) {
            form.imageList = form.imageList.concat(res.data.split(','))
          } else {
            arr = [...arr, ...res.data.split(',')]
          }
          this.uploadImageList = []
        }).finally(() => {
          this.imageLoading = false
        })
      })
    },
    // 图片压缩
    imageCompressorHandle(file) {
      let width = file.width
      let height = file.height
      if (file.width > 800) {
        width = 800
        height = file.width / file.height * 800
      }
      return new Promise((resolve, reject) => {
        new ImageCompressor({
          file,
          quality: 0.4, // 压缩质量
          width: width,
          height: height,
          mimeType: file.type === 'image/webp' ? 'image/jpeg' : 'auto',
          success(result) {
            resolve(result)
          }
        })
      })
    },
    imgVisit(imgUrl) {
      this.dialogImageUrl = imgUrl
      this.dialogVisible = true
    },
    imgUrlDelete(arr, index) {
      arr.splice(index, 1)
    },
    
  }
}
</script>

<style lang="scss" scoped>
  .tips {
    display: block;
    color: #f56c6c;
    margin-left: 80px;
  }
  /deep/.el-upload--picture-card {
    width: 70px;
    height: 72px;
    position: relative;
    margin-right: 10px;
  }
  /deep/.el-icon-plus {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .imageListBox {
      padding: .1rem;
      .uploadBox {
        width: 70px;
        height: 72px;
      }
      .pictureCard {
        margin: 0 10px 10px 0;
        position: relative;
        width: 70px;
        height: 72px;
        border-radius: 6px;
        border: 1px solid #CDD4DD;
        cursor: pointer;
        >img {
            height: 100%;
            width: 100%;
            border-radius: 6px;
        }
        .deleteIcon {
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 30px;
            border-radius: 2px 6px 2px 30px;
            background: rgba(71, 71, 71, 0.6);
            transition: background .5s 0s;
            cursor: pointer;
        }
        .deleteIcon:hover {
            background: rgba(19, 18, 18, 0.6);
        }
        .el-icon-close {
            position: absolute;
            top: 6px;
            right: 6px;
            color: #fff;
            cursor: pointer;
            z-index: 10;
        }
        .el-icon-close:hover ~ .deleteIcon {
            background: rgba(19, 18, 18, 0.6);
        }
      }
    }
</style>
